import { IBrowseState } from "../models";
import { BrowseActionTypes } from "../models/browseActions";
import { CHANGE_SORT } from "../types";

export default (type: IBrowseState["sorting"]): BrowseActionTypes => ({
    type: CHANGE_SORT,
    payload: type,
});
